import { Row } from "antd"
import { Button, Space } from "components/common"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import theme from "utils/themeVars"
import { useState, useMemo, useCallback } from "react"
import ProgressItem from "./progressItem"
import ProgressFormLeftMenu from "./progressFormLeftMenu"
import ProgressFormDetail from "./progressFormDetail"


const ProgressStepper = ({
  stagesFormsHash,
  stages,
  title,
  formHookList = [],
  detailData: detail,
  mutationLoading,
  stepsToSkipOnEdit = [],
  showBackButton = false,
  onSuccessAfterEveryStep,
  onCancel,
  id,
  error,
  onErrorRetry,
  loading,
}) => {
  const { t } = useTranslation()
  const [progressState, setProgressState] = useState({ ...stages(false)[0], index: 0 })
  const stageSlug = Object.keys(stagesFormsHash())[progressState?.index]
  const navigate = useNavigate()
  const [s3loading, setS3Loading] = useState()

  const progressStages = useMemo(
    () =>
      stages()?.map((e, i) => {
        const isComplete = !!detail?.[e?.slug]?.complete
        return {
          ...e,
          index: i,
          complete: isComplete,
          disabled: !(isComplete || detail[stages()[i - 1]?.slug]?.complete) || s3loading,
        }
      }),
    [s3loading, detail, stages]
  )

  const onStageClick = item => {
    setProgressState(prev => ({ ...prev, ...item }))
  }

  const handleStepSuccess = () => {
    const newIndex = progressState.index + 1
    setProgressState(prev => ({ ...prev, index: newIndex }))
    if (progressState.index !== 0) {
      onSuccessAfterEveryStep?.()
    }
  }

  const handleNext = () => {
    const form = formHookList[progressState.index]
    if (!form) return
    if (id && stepsToSkipOnEdit?.includes(progressState.index)) {
      handleStepSuccess()
      return
    }
    form.submit()
  }

  const handleCancelClick = () => {
    if (onCancel) {
      onCancel()
      return
    }
    navigate(-1)
  }

  const renderStageForm = useCallback(
    () => {
      const Component = stagesFormsHash()[stageSlug]?.Component
      return Component ? (
        <Component
          form={formHookList[progressState.index]}
          formData={stagesFormsHash()[stageSlug]?.formData}
          disableForm={detail?.[stageSlug]?.disabled}
          setLoading={setS3Loading}
          id={id}
          onStepSuccess={handleStepSuccess}
        />
      ) : null
    },
    [progressState, detail, formHookList, stagesFormsHash, stageSlug, mutationLoading]
  )

  return (
    <>
      <Row gutter={16} className="mbe-16 flexGrow">
        <ProgressFormLeftMenu
          showBackButton={showBackButton}
          title={title}
          progressItems={progressStages}
          listItem={(item, index) => {
            return (
              <ProgressItem
                key={item?.slug}
                stage={item}
                active={item?.slug === stageSlug}
                complete={item.complete}
                onStageClick={() => onStageClick(item)}
                disabled={item.disabled}
                loading={loading}
              />
            )
          }}
        />
        <ProgressFormDetail
          mainTitle={stagesFormsHash()[stageSlug]?.heading}
          subTitle={stagesFormsHash()[stageSlug]?.subText}
          error={error}
          onErrorRetry={onErrorRetry}
          loading={loading}
          topRightItem={stagesFormsHash()[stageSlug]?.topRightItem}
        >
          {renderStageForm()}
        </ProgressFormDetail>
      </Row>
      <Row justify="end">
        <Space size={12}>
          <Button
            disabled={false}
            text={t("Cancel")}
            onClick={handleCancelClick}
            className="pi-20"
            size="large"
            color={theme["error-color"]}
            bordered
            danger
          />
          <Button
            type="primary"
            loading={mutationLoading || s3loading}
            disabled={s3loading || !!error || loading}
            text={stagesFormsHash()[stageSlug]?.nextButtonText ?? t("Next")}
            onClick={handleNext}
            className="pi-32"
            size="large"
          />
        </Space>
      </Row>
    </>
  )
}

export default ProgressStepper
